// The sweep date in the Øvrige kjøretøy notice (#640). The backend sends UTC
// with a Z; the user reads the calendar day in Oslo, so a check at 23:30 UTC on
// the 23rd is the 24th.

const OSLO_YMD = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Oslo', year: 'numeric', month: '2-digit', day: '2-digit',
})

/** YYYY-MM-DD of the instant, in Europe/Oslo. */
export function osloYmd(instant: string | Date): string {
  return OSLO_YMD.format(typeof instant === 'string' ? new Date(instant) : instant)
}

/** Whole Oslo calendar days from the instant to now. */
export function osloDaysAgo(instant: string, now: Date = new Date()): number {
  const day = (ymd: string) => Date.parse(`${ymd}T00:00:00Z`)
  return Math.round((day(osloYmd(now)) - day(osloYmd(instant))) / 86_400_000)
}
